import React, { useEffect, useState, useRef } from 'react';
import { ApiEmailService } from '../../config/apiService';
import {
  getEmailQueryParams,
  getUnstyledHtmlBody,
  mailButtonGroup,
} from '../../utils/email';
import { scrollIntoView } from '../../utils/general';
import { EmailPageWrapper } from './SharedComponents/EmaliPageWrapper';
import ContactModal from '../../components/Modal/ContactModal';
import { apiPaths } from '../../config/apiPaths';

const Sent = (props) => {
  const [emails, setEmails] = useState([]);
  const [totalCount, setTotalCount] = useState(null);

  const [selectedEmails, setSelectedEmails] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState(null);

  const cleanup = useRef(false);

  const [folders, setFolders] = useState([]);

  const [selectedFolder, setSelectedFolder] = useState(-1);

  const [forward, setForward] = useState({
    open: false,
    id: null,
    folder_id: null,
  });

  const {
    match: {
      params: { mailId },
    },
  } = props;
  useEffect(() => {
    if (totalCount > 0 && mailId) {
      selectEmail(mailId);
    }
    // eslint-disable-next-line
  }, [mailId, totalCount]);

  const getFolders = async () => {
    const data = await ApiEmailService.getEmails('getFolders', []);
    if (data !== undefined && !cleanup.current) {
      setFolders([...data]);
    }
  };

  const selectEmail = (id, xref_id, multi = false, is_detail_view = false) => {
    if (is_detail_view) {
      if (Array.isArray(id)) {
        getEmailDetails(id[id.length - 1]).then(() => {
          scrollIntoView('selected-mail-details');
        });
      } else {
        getEmailDetails(id).then(() => {
          scrollIntoView('selected-mail-details');
        });
      }
      return;
    }

    if (Array.isArray(id)) {
      let is_same =
        selectedEmails.length === id.length &&
        selectedEmails.every(function (element, index) {
          return element === id[index];
        });
      if (is_same) {
        setSelectedEmails([]);
      } else {
        setSelectedEmails(id);
        const index = emails.findIndex((x) => x.mail_id === id[id.length - 1]);

        if (index !== -1 && emails[index].read === false) {
          const _emails = [...emails];
          _emails[index].read = true;
          setEmails(_emails);
        }
        getEmailDetails(id[id.length - 1]).then(() => {});
      }
    } else {
      const index = emails.findIndex((x) => x.mail_id === id);

      if (index !== -1 && emails[index].read === false) {
        const _emails = [...emails];
        _emails[index].read = true;
        setEmails(_emails);
      }
      getEmailDetails(id).then(() => {});

      let findItem = selectedEmails.findIndex((el) => el === id);

      if (findItem === -1) {
        setSelectedEmails([...selectedEmails, id]);
      } else {
        let newSelected = [...selectedEmails];
        newSelected.splice(findItem, 1);
        setSelectedEmails([...newSelected]);
      }
    }
  };

  const bottomButtonsHandlers = {
    [mailButtonGroup.mailForward.name]: async (event) => {
      if (selectedEmail) {
        setForward({
          open: true,
          id: selectedEmail.mail_id,
          folder_id: selectedEmail.folder_id,
        });
      }
    },
  };

  const topButtonsHandlers = {
    [mailButtonGroup.mailStarred.name]: async (event) => {
      if (selectedEmail) {
        let res = null;
        if (selectedEmails.length === 1) {
          res = await ApiEmailService.postEmail('postEmailStar', {
            mail_id: selectedEmail.mail_id,
            xref_id: selectedEmail.xref_id,
            rm: selectedEmail.is_stared,
          });
        } else {
          let xref_id = [];
          selectedEmails.forEach((el) => {
            emails.forEach((email) => {
              if (email.mail_id === el) {
                xref_id.push(email.xref_id);
              }
            });
          });
          res = await ApiEmailService.postEmail('postEmailStar', {
            mail_id: selectedEmails,
            xref_id: xref_id,
            rm: selectedEmail.is_stared,
          });
        }
        if (res.success) {
          await getEmails();
          setSelectedEmail({
            ...selectedEmail,
            is_stared: !selectedEmail.is_stared,
          });
          setSelectedEmails([]);
        }
      }
    },
    [mailButtonGroup.mailTrash.name]: async (event) => {
      if (selectedEmail) {
        let res = null;
        if (selectedEmails.length === 1) {
          res = await ApiEmailService.postEmail('postEmailToTrash', {
            mail_id: selectedEmail.mail_id,
            xref_id: selectedEmail.xref_id,
          });
        } else {
          let xref_id = [];
          selectedEmails.forEach((el) => {
            emails.forEach((email) => {
              if (email.mail_id === el) {
                xref_id.push(email.xref_id);
              }
            });
          });
          res = await ApiEmailService.postEmail('postEmailToTrash', {
            mail_id: selectedEmails,
            xref_id: xref_id,
          });
        }
        if (res.success) getEmails();
        setSelectedEmails([]);
      }
    },
    [mailButtonGroup.mailFolder.name]: {
      folders: () => {
        return folders;
      },
      moveEmailToFolder: async (folder_id) => {
        let response = null;
        if (selectedEmails.length === 1) {
          response = await ApiEmailService.postEmail('moveEmailToFolder', {
            folder_id,
            mail_id: selectedEmail.mail_id,
            xref_id: selectedEmail.xref_id,
          });
        } else {
          let xref_id = [];
          selectedEmails.forEach((el) => {
            emails.forEach((email) => {
              if (email.mail_id === el) {
                xref_id.push(email.xref_id);
              }
            });
          });
          response = await ApiEmailService.postEmail('moveEmailToFolder', {
            folder_id,
            mail_id: selectedEmails,
            xref_id: xref_id,
          });
        }
        if (response.success) getEmails();
        setSelectedEmails([]);
      },
    },
  };

  const getEmails = async (start_id) => {
    let params = getEmailQueryParams(
      start_id,
      selectSort,
      props.search,
      selectedFolder,
      props.contact_filter
    );

    let tmp_data = await ApiEmailService.getEmails('getSent', params);
    let { data, total } = tmp_data !== undefined ? tmp_data : {};

    if (data !== undefined && !cleanup.current) {
      data.forEach((email) => {
        email.noStyleBody = getUnstyledHtmlBody(email.body);
      });

      setSelectedEmail(null);
      data = data.map((el) => {
        el.read = true;
        return el;
      });
      if (start_id) {
        setEmails([...emails, ...data]);
      } else {
        setEmails([...data]);
      }
    }

    if (total && !cleanup.current) {
      setTotalCount(total);
    }
  };

  const getEmailDetails = async (id) => {
    let data = await ApiEmailService.getEmailDetails('getSendEmailDetails', id);
    let reply;
    if (data.reply && data.reply.id) {
      reply = await ApiEmailService.getEmailDetails(
        'getInboxEmailDetails',
        data.reply.id
      );
      reply.id = data.reply.id;
      data.reply = reply;
    }
    setSelectedEmail({ ...data, mail_id: id });
  };

  const [selectSort, setSelect] = React.useState(0);

  useEffect(() => {
    getEmails();
    getFolders();
    const params = new URLSearchParams(props.location.search);
    const mail_id = params.get('mail_id');
    if (mail_id) {
      selectEmail(mail_id);
    }
    return () => {
      cleanup.current = true;
    };
    // eslint-disable-next-line
  }, [selectSort, selectedFolder, props.location.search]);

  useEffect(() => {
    props.setMemberUrl(apiPaths.mail.getSelectableMembersSent);
    // eslint-disable-next-line
  }, [props.setMemberUrl]);

  const handleChangeSort = (e) => {
    setSelect(e.target.value);
    getEmails(null, e.target.value);
  };
  // "TODO: this block is not needed anymore, shall we keep this block or remove ?"
  // const [selectFilter, setSelectFilter] = React.useState(0);
  // const handleChangeFilter = (e) => {
  //   setSelectFilter(e.target.value);
  // };
  const handleEditFolder = async (folder_id, folder_name) => {
    const res = await ApiEmailService.postEmail('postFolder', {
      folder_id,
      folder_name,
    });
    if (res.success) getFolders();
  };

  const handleRemoveFolder = async (folder_id) => {
    const res = await ApiEmailService.deleteFolder('deleteFolder', folder_id);
    if (res.success) {
      let newFoldersData = [...folders];
      newFoldersData.splice(
        folders.findIndex((el) => el.id === res.id),
        1
      );
      setFolders([...newFoldersData]);
    }
  };
  return (
    <EmailPageWrapper
      section="Sent"
      view={props.view}
      selectedEmail={selectedEmail}
      selectedEmails={selectedEmails}
      emails={emails}
      totalCount={totalCount}
      sortControls={{
        value: selectSort,
        changeValue: handleChangeSort,
      }}
      // "TODO: this block is not needed anymore, shall we keep this block or remove ?"
      // filterControls={{
      //   value: selectFilter,
      //   changeValue: handleChangeFilter,
      // }}
      bottomButtonsHandlers={bottomButtonsHandlers}
      topButtonsHandlers={topButtonsHandlers}
      selectEmail={selectEmail}
      showFolders={true}
      getFolders={getFolders}
      folders={folders}
      handleEditFolder={handleEditFolder}
      handleRemoveFolder={handleRemoveFolder}
      selectedFolder={selectedFolder}
      setSelectedFolder={setSelectedFolder}
    >
      {forward.open && (
        <ContactModal
          forward
          mail_id={forward.id}
          folder_id={forward.folder_id}
          open={true}
          onClose={() => {
            setForward({ open: false });
          }}
        />
      )}
    </EmailPageWrapper>
  );
};

export default Sent;
